$(function() {

    function slidein_menu() {
        $('.mobile-menus').stop().slideDown();
    }
    function slideout_menu() {
        $('.mobile-menus').stop().slideUp();
    }
    
    
    $('.hamburger').on('click', function(){
        $(this).toggleClass('is-active');
        $('.mobile-menus').toggleClass('is-active');
        if($('.mobile-menus').hasClass('is-active')){
            slidein_menu();
        }
        else{
            slideout_menu();
        }
    });
    
    $('.mobile-menu__ul--primary > li').on('click', function(){
        $('.mobile-menu__ul--secondary').slideUp();
        if(!$(this).find('.mobile-menu__ul--secondary').is(':visible')){
            $(this).find('.mobile-menu__ul--secondary').slideDown();
        }
        
    });

        $('.menu__ul--primary > li').hoverIntent({
        over : function(){
            $(this).find('.menu__ul--secondary').fadeIn();
        },
        timeout : 600,
        out: function(){
            $(this).find('.menu__ul--secondary').fadeOut();
        }

    });

    $('.menu__ul--secondary > li').hoverIntent({
        over : function(){
            $(this).find('.menu__ul--tertiary').fadeIn();
        },
        timeout : 600,
        out: function(){
            $(this).find('.menu__ul--tertiary').fadeOut();
        }

    });



});
